/**
 * Remembers the deal a user last opened so the dashboard can offer a
 * "Resume last deal" card (UI-POLISH-2 / Tier 1 ITEM 1, analyst landing).
 *
 * localStorage, not server state: it is a per-browser convenience, and losing it
 * costs the user one extra click.
 */
const KEY = 'qoe_last_deal'

export interface LastDeal {
  deal_id: string
  business_name: string
}

export function rememberLastDeal(deal: LastDeal): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(deal))
  } catch { /* private mode / quota — the card just won't appear */ }
}

export function getLastDeal(): LastDeal | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<LastDeal>
    if (!parsed?.deal_id) return null
    return { deal_id: parsed.deal_id, business_name: parsed.business_name || 'Untitled deal' }
  } catch {
    return null
  }
}
